import { render, staticRenderFns } from "./EvaluationGrid.vue?vue&type=template&id=edc53f94"
import script from "./EvaluationGrid.vue?vue&type=script&lang=js"
export * from "./EvaluationGrid.vue?vue&type=script&lang=js"
import style0 from "./EvaluationGrid.vue?vue&type=style&index=0&id=edc53f94&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports